"use strict";
import {
  PermitMethod
} from "features/transactions/swap/types/swapTxAndGasInfo";
export var LiquidityTransactionType = /* @__PURE__ */ ((LiquidityTransactionType2) => {
  LiquidityTransactionType2["Create"] = "create";
  LiquidityTransactionType2["Increase"] = "increase";
  LiquidityTransactionType2["Decrease"] = "decrease";
  LiquidityTransactionType2["Migrate"] = "migrate";
  LiquidityTransactionType2["Collect"] = "collect";
  return LiquidityTransactionType2;
})(LiquidityTransactionType || {});
export function isValidLiquidityTxContext(liquidityTxContext) {
  return validateLiquidityTxContext(liquidityTxContext) !== void 0;
}
function validateLiquidityTxContext(liquidityTxContext) {
  if (!isLiquidityTx(liquidityTxContext)) {
    return void 0;
  }
  if (liquidityTxContext.type === "collect" /* Collect */) {
    if (liquidityTxContext.txRequest) {
      return { ...liquidityTxContext, txRequest: liquidityTxContext.txRequest };
    }
    return void 0;
  }
  if (liquidityTxContext.action) {
    const { action, txRequest, permit } = liquidityTxContext;
    const unsigned = (liquidityTxContext.type === "increase" || liquidityTxContext.type === "create") && liquidityTxContext.unsigned;
    if (unsigned) {
      if (!permit || permit.method !== PermitMethod.TypedData) {
        return void 0;
      }
      return { ...liquidityTxContext, action, unsigned, txRequest: void 0, permit };
    } else if (txRequest) {
      return { ...liquidityTxContext, action, unsigned, txRequest, permit: void 0 };
    }
  }
  return void 0;
}
function isLiquidityTx(liquidityTxContext) {
  return typeof liquidityTxContext === "object" && liquidityTxContext !== null && "action" in liquidityTxContext && "protocolVersion" in liquidityTxContext;
}
